import React, { useState, useEffect } from 'react'
import { string, array } from 'prop-types'
import { css } from '@emotion/react'
import {
  TabsList,
  Tab,
  TabsWrapper,
} from '@livechat/design-system-react-components'

import mediaQueries from '@/layout/media-queries'

const wrapperCss = (theme) => css`
  width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
  scrollbar-width: thin;
  scrollbar-gutter: stable;
  margin-bottom: 32px;

  @media (max-width: ${mediaQueries.BASE_SMALL_SIZE - 1}px) {
    position: sticky;
    background-color: ${theme.colors.white};
    padding-top: 7px;
    top: 105px;
    z-index: 3;
  }
`

const tabCss = css`
  white-space: nowrap;
`

const tabsWrapperCss = css`
  min-width: min-content;
`

const Tabs = ({ activeTab, tabs, className }) => {
  const initialTab = tabs?.[0]?.id || null
  const [selectedTab, setSelectedTab] = useState(initialTab)

  useEffect(() => {
    setSelectedTab(activeTab)
  }, [activeTab])

  const handleTabChange = (id) => {
    setSelectedTab(id)

    // We have transition which changes the height of the header, causing anchor to be offset by few pixels.
    // In order to fix it we will scroll down to trigger the transition and then wait 200ms
    // in order to transition to ends and scroll.
    window.scrollBy(0, 1)
    setTimeout(() => {
      document.getElementById(id).scrollIntoView({ behavior: 'smooth' })
    }, 200)
  }

  return (
    <div css={wrapperCss} className={className}>
      <TabsWrapper css={tabsWrapperCss}>
        <TabsList>
          {tabs.map(({ id, title }) => (
            <Tab
              css={tabCss}
              onClick={() => handleTabChange(id)}
              key={id}
              isSelected={selectedTab === id}
              size="compact"
            >
              {title}
            </Tab>
          ))}
        </TabsList>
      </TabsWrapper>
    </div>
  )
}

Tabs.propTypes = {
  className: string,
  activeTab: string,
  tabs: array,
}

export default Tabs
